import { Component } from '@theme/component';
import { bindScrollArrows } from '@theme/ca-scroll-arrows';

/**
 * "Shop the story" rail carousel.
 *
 * The rail chooses grid vs carousel in Liquid from the number of products (see
 * sections/ca-article-shop-the-story.liquid). This component only drives the carousel state:
 * the prev/next arrows and their disabled state. When the section renders a desktop grid the
 * track is not scrollable, the arrows are hidden by CSS, and everything here is inert.
 *
 * `slideshow-arrow.liquid` emits `on:click="/previous"` / `on:click="/next"`, so the delegated
 * Horizon binding calls the methods below — no manual addEventListener wiring.
 */
export default class CaStoryShop extends Component {
  requiredRefs = ['track'];

  #arrows = null;

  connectedCallback() {
    super.connectedCallback();

    const { track, previous, next } = this.refs;
    if (!track) return;

    this.#arrows = bindScrollArrows(track, previous, next, {
      clicks: false,
      onChange: ({ overflowing }) => {
        if (overflowing) track.setAttribute('tabindex', '0');
        else track.removeAttribute('tabindex');
      },
      step: () => {
        const card = track.querySelector('.ca-story-shop__cell');
        if (!card) return track.clientWidth * 0.8;
        const gap = parseFloat(getComputedStyle(track).columnGap);
        return card.getBoundingClientRect().width + (Number.isFinite(gap) ? gap : 0);
      },
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#arrows?.disconnect();
    this.#arrows = null;
  }

  next() {
    this.#arrows?.scroll(1);
  }

  previous() {
    this.#arrows?.scroll(-1);
  }
}

if (!customElements.get('ca-story-shop')) {
  customElements.define('ca-story-shop', CaStoryShop);
}
